import { render, staticRenderFns } from "./ListWithSubtitles.vue?vue&type=template&id=63526d05&scoped=true"
import script from "./ListWithSubtitles.vue?vue&type=script&lang=js"
export * from "./ListWithSubtitles.vue?vue&type=script&lang=js"
import style0 from "./ListWithSubtitles.vue?vue&type=style&index=0&id=63526d05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63526d05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemTitle})
